/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  area_division_id: z.number(),
  name: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const CarryInLocationBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type CarryInLocationBase = z.infer<typeof base>;
export type CarryInLocationBasePutPayload = z.infer<typeof put>;
export type CarryInLocationBasePatchPayload = z.infer<typeof patch>;
export type CarryInLocationBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type CarryInLocationBaseCreateAttributes = z.infer<typeof create>;
export type CarryInLocationBaseUpdateAttributes = z.infer<typeof update>;
export type CarryInLocationBaseCacheAttributes = z.infer<typeof cache>;
export type CarryInLocationBaseCachesAttributes = z.infer<typeof caches>;